import { render, staticRenderFns } from "./TagFilter.vue?vue&type=template&id=5bdbef28&scoped=true&"
import script from "./TagFilter.vue?vue&type=script&lang=js&"
export * from "./TagFilter.vue?vue&type=script&lang=js&"
import style0 from "./TagFilter.vue?vue&type=style&index=0&id=5bdbef28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbef28",
  null
  
)

export default component.exports